export default class RicercaAgenti {
    constructor(node) {
        this.node = node;

        this.listingAgenti = node.querySelector('.listing-agenti');

        this.filtroBrand = node.querySelector('select[name="brand"]');
        this.filtroNazione = node.querySelector('select[name="nazione"]');
        this.filtroRegione = node.querySelector('select[name="regione"]');
        this.filtroProvincia = node.querySelector('select[name="provincia"]');
        
        this.addListeners();
    }

    addListeners() {
        let _this = this;

        // filtro primo livello
        this.filtroBrand.addEventListener('change', function() {
            if (!this.value) {
                return;
            }

            let responseData = {};

            let submittedData = {
                data: {
                    brand: this.value,
                },
            };

            _this.hideAllFilters();
            _this.clearAllListings();

            _this.pushHistory(this.querySelector('[value="' + this.value + '"]').dataset.url);

            $.ajax({
                type: "POST",
                url: "/WS/wsRicercaAgenti.asmx/SelectBrand",
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: "json",
                success: function(data) {
                    responseData = data;

                    let options = JSON.parse(responseData.d.Props.nazioni);
                    _this.updateSelect(_this.filtroNazione, options);
                    if (Object.keys(options).length) {
                        _this.showFilter(_this.filtroNazione);
                    }

                    _this.updateListing(responseData.d.HTML);
                },
                error: function(data) {
                    responseData = data;
                },
                complete: function() {
                    // console.log(responseData);
                }
            });
        });

        // filtro secondo livello
        this.filtroNazione.addEventListener('change', function() {
            if (!this.value) {
                return;
            } 
            
            let responseData = {};

            let submittedData = {
                data: {
                    nazione: this.value,
                },
            };

            _this.hideFilter(_this.filtroRegione);
            _this.hideFilter(_this.filtroProvincia);
            _this.clearAllListings();

            _this.pushHistory(this.querySelector('[value="' + this.value + '"]').dataset.url);

            $.ajax({
                type: "POST",
                url: "/WS/wsRicercaAgenti.asmx/SelectNazione",
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: "json",
                success: function(data) {
                    responseData = data;

                    let options = JSON.parse(responseData.d.Props.regioni);
                    _this.updateSelect(_this.filtroRegione, options);
                    if (Object.keys(options).length) {
                        _this.showFilter(_this.filtroRegione);        
                    }
                    
                    _this.updateListing(responseData.d.HTML);
                },
                error: function(data) {
                    responseData = data;
                },
                complete: function() {
                    // console.log(responseData);
                }
            });
        });

        // filtro terzo livello
        this.filtroRegione.addEventListener('change', function() {
            if (!this.value) {
                return;
            }

            let responseData = {};

            let submittedData = {
                data: {
                    nazione: _this.filtroNazione.value,
                    regione: this.value,
                },
            };

            _this.hideFilter(_this.filtroProvincia);
            _this.clearAllListings();

            _this.pushHistory(this.querySelector('[value="' + this.value + '"]').dataset.url);

            $.ajax({
                type: "POST",
                url: "/WS/wsRicercaAgenti.asmx/SelectRegione",
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: "json",
                success: function(data) {
                    responseData = data;

                    let options = JSON.parse(responseData.d.Props.province);
                    _this.updateSelect(_this.filtroProvincia, options);
                    if (Object.keys(options).length) {
                        _this.showFilter(_this.filtroProvincia);
                    }

                    _this.updateListing(responseData.d.HTML);
                },
                error: function(data) {
                    responseData = data;
                },
                complete: function() {
                    // console.log(responseData);
                }
            });
        });

        // filtro quarto livello
        this.filtroProvincia.addEventListener('change', function() {
            if (!this.value) {
                return;
            }

            let responseData = {};

            let submittedData = {
                data: {
                    nazione: _this.filtroNazione.value,
                    regione: _this.filtroRegione.value,
                    provincia: this.value,
                },
            };
            _this.clearAllListings();

            _this.pushHistory(this.querySelector('[value="' + this.value + '"]').dataset.url);

            $.ajax({
                type: "POST",
                url: "/WS/wsRicercaAgenti.asmx/SelectProvincia",
                cache: false,
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(submittedData),
                dataType: "json",
                success: function(data) {
                    responseData = data;
                    _this.updateListing(responseData.d.HTML);
                },
                error: function(data) {
                    responseData = data;
                },
                complete: function() {
                    // console.log(responseData);
                }
            });
        });

        /*
        window.addEventListener('popstate', function(event) {
            if (event.state && event.state.type != undefined && event.state.type === 'download') {
                let selectedOption = _this.filtroTipoNode.querySelector('option[data-url="' + event.state.url + '"]');

                _this.filtroTipoNode.options[selectedOption.index].selected = true;
                _this.filtroTipoNode.dispatchEvent(new Event('change'));
            }
        });
         */
    }

    pushHistory(url) {
        if (!history.state || history.state.url != url) {
            history.pushState({ type: 'download', url: url }, "", url);
        }
    }
    
    updateListing(html) {
        this.listingAgenti.innerHTML = html;
    }

    clearAllListings() {
        this.listingAgenti.innerHTML = "";
    }

    showFilter(filterNode) {
        filterNode.closest('.filtro').style.display = "block";
    }

    hideFilter(filterNode) {
        filterNode.closest('.filtro').style.display = "none";
        filterNode.querySelector('option:first-child').selected = 'selected';
    }

    hideAllFilters() {
        // Nasconde tutti i filtri (tranne il primo livello).
        this.node.querySelectorAll('.filtro:not(.filtro-brand)').forEach(function(filtroNode) {
            filtroNode.style.display = "none";
            filtroNode.querySelector('option:first-child').selected = 'selected';
        });
    }

    updateSelect(selectNode, options) {
        selectNode.options.length = 1;

        for (let item of options) {
            let option = document.createElement("option");

            option.value = item.Key;
            option.text = item.Value;

            selectNode.add(option);
        }
    }

    static init() {
        let ricercaAgentiNode = document.querySelector("[data-ricerca-agenti]");

        if (ricercaAgentiNode) {
            return new RicercaAgenti(ricercaAgentiNode);
        }
    }
}
